import VueTippy from 'vue-tippy'
import { roundArrow, animateFill, sticky } from 'tippy.js'

export default defineNuxtPlugin(() => {
  const { vueApp } = useNuxtApp()
  vueApp.use(VueTippy, {
    directive: 'tippy',
    component: 'tippy',
    componentSingleton: 'tippy-singleton',
    defaultProps: {
      arrow: roundArrow,
      placement: 'auto-end',
      allowHTML: true,
      animateFill: true,
      interactive: true,
      animation: 'scale',
      duration: [300, 50],
      moveTransition: 'transform 0.2s ease-out',
      plugins: [animateFill, sticky],
      sticky: 'popper',
      onClickOutside (instance: any) {
        instance.hide()
      }
    }
  })
})
